var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"index"}},[_c('keep-alive',[_c('router-view',{attrs:{"to":"/index/home"}})],1),_c('FooterView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }